import { GetActionPath } from './GetActionPath';
import { GetActionPathCount } from './GetActionPathCount';
import { GetActionPathInitiatives } from './GetActionPathInitiatives';
import { GetActionPathStatistics } from './GetActionPathStatistics';
import { GetActionPathTrackerStatus } from './GetActionPathTrackerStatus';
import { GetValidActionPathName } from './GetValidActionPathName';
import { ListActionPaths } from './ListActionPaths';

/**
 * queries
 *
 * @type {{GetActionPathStatistics: ((function({}=): Promise<*>)|*), GetValidActionPathName: ((function({}=):
 *     Promise<*>)|*), GetActionPathTrackerStatus: ((function({}=): Promise<*>)|*), ListActionPaths: ((function({}=):
 *     Promise<*>)|*), GetActionPathInitiatives: ((function({}=): Promise<*>)|*), GetActionPathCount: ((function({}=):
 *     Promise<*>)|*), GetActionPath: ((function({}=): Promise<*>)|*)}}
 */
export const queries = {
  GetActionPath,
  GetActionPathCount,
  GetActionPathInitiatives,
  GetActionPathStatistics,
  GetActionPathTrackerStatus,
  GetValidActionPathName,
  ListActionPaths,
};
